export default __webpack_public_path__ + "Invest logo.svg";